import { useState } from "react";
import React from "react";
import { I_Check, I_X } from "./icons";
import { Spinner } from "./ui";
import { logActivity } from "../lib/activity.js";
import { btnG, btnP, glassDeep, heading, input, label } from "../styles.js";
import { sb } from "../supabase.js";

const AddVisitModal = ({ initialPropertyId, clients, properties, session, onClose, onSaved }) => {
    const [propertyId, setPropertyId] = useState(initialPropertyId || "");
    const [clientId, setClientId] = useState("");
    const [walkin, setWalkin] = useState("");
    const [when, setWhen] = useState(() => {
      const d = new Date();
      d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
      return d.toISOString().slice(0, 16);
    });
    const [note, setNote] = useState("");
    const [scheduled, setScheduled] = useState(false);
    const [busy, setBusy] = useState(false);
    const save = async () => {
      if (!propertyId) {
        alert("Pick a property.");
        return;
      }
      if (!clientId && !walkin.trim()) {
        alert("Pick a client or enter a walk-in name.");
        return;
      }
      setBusy(true);
      const visited_at = new Date(when).toISOString();
      const row = {
        property_id: propertyId,
        client_id: clientId || null,
        walkin_name: clientId ? null : walkin.trim(),
        visited_at,
        is_scheduled: scheduled,
        note: note.trim() || null,
        created_by: session.user.id,
      };
      const { error } = await sb.from("visits").insert(row);
      if (!error) {
        const p = properties.find((x) => x.id === propertyId),
          c = clients.find((x) => x.id === clientId);
        const who = c?.name || walkin.trim() || "Walk-in";
        logActivity(
          session.user.id,
          "visit",
          scheduled ? "visit" : "property",
          propertyId,
          `${scheduled ? "Scheduled visit:" : "Logged visit:"} ${who} at ${p?.title || "property"}`,
        );
        onSaved();
        onClose();
      } else {
        alert("Couldn't save: " + error.message);
      }
      setBusy(false);
    };
    return (
      <React.Fragment>
        <div
          className="fixed inset-0 bg-slate-950/60 backdrop-blur-sm z-50 animate-[fadein_.15s]"
          onClick={onClose}
        />
        <div
          className={`fixed left-1/2 top-12 -translate-x-1/2 w-[92vw] max-w-md z-[55] ${glassDeep} rounded-2xl shadow-2xl animate-[fadein_.15s]`}
        >
          <div className="px-5 py-3 border-b border-white/[0.06] flex items-center justify-between">
            <h3 className="text-lg text-slate-100" style={heading}>
              Log a visit
            </h3>
            <button
              onClick={onClose}
              className="text-slate-400 hover:text-slate-200 p-1.5 rounded hover:bg-white/[0.06]"
            >
              <I_X size={16} />
            </button>
          </div>
          <div className="p-5 space-y-3">
            <div>
              <label className={label}>Property *</label>
              <select
                value={propertyId}
                onChange={(e) => setPropertyId(e.target.value)}
                className={input}
              >
                <option value="">— pick a property —</option>
                {properties.map((p) => (
                  <option key={p.id} value={p.id}>
                    {p.code ? p.code + " · " : ""}
                    {p.title}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label className={label}>Client</label>
              <select
                value={clientId}
                onChange={(e) => {
                  setClientId(e.target.value);
                  if (e.target.value) setWalkin("");
                }}
                className={input}
              >
                <option value="">— or walk-in below —</option>
                {clients.map((c) => (
                  <option key={c.id} value={c.id}>
                    {c.name}
                    {c.phone ? " · " + c.phone : ""}
                  </option>
                ))}
              </select>
            </div>
            {!clientId && (
              <div>
                <label className={label}>Walk-in name</label>
                <input
                  value={walkin}
                  onChange={(e) => setWalkin(e.target.value)}
                  placeholder="If they aren't in your contacts yet"
                  className={input}
                />
              </div>
            )}
            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className={label}>When</label>
                <input
                  type="datetime-local"
                  value={when}
                  onChange={(e) => setWhen(e.target.value)}
                  className={input}
                />
              </div>
              <div>
                <label className={label}>Type</label>
                <select
                  value={scheduled ? "scheduled" : "logged"}
                  onChange={(e) => setScheduled(e.target.value === "scheduled")}
                  className={input}
                >
                  <option value="logged">Already happened</option>
                  <option value="scheduled">Upcoming / scheduled</option>
                </select>
              </div>
            </div>
            <div>
              <label className={label}>Note</label>
              <textarea
                value={note}
                onChange={(e) => setNote(e.target.value)}
                rows={2}
                className={`${input} resize-y`}
                placeholder="What happened, any signals…"
              />
            </div>
            <div className="flex justify-end gap-2 pt-1">
              <button onClick={onClose} className={btnG}>
                Cancel
              </button>
              <button onClick={save} disabled={busy} className={`${btnP} disabled:opacity-50`}>
                {busy ? <Spinner size={13} /> : <I_Check size={13} />}Save visit
              </button>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  };

export { AddVisitModal };
